"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _controlSelect = _interopRequireDefault(require("@mapbox/mr-ui/control-select"));
var _copyButton = _interopRequireDefault(require("@mapbox/mr-ui/copy-button"));
var _tooltip = _interopRequireDefault(require("@mapbox/mr-ui/tooltip"));
var _icon = _interopRequireDefault(require("@mapbox/mr-ui/icon"));
var _xyInput = require("./components/xy-input");
var _sliderInput = require("./components/slider-input");
var _numberInput = require("./components/number-input");
var _eyedropperInput = require("./components/eyedropper-input");
var _colorString = _interopRequireDefault(require("color-string"));
var _reactThemeable = _interopRequireDefault(require("react-themeable"));
var _theme = require("./theme");
var _autokey = require("./autokey");
var _colorfunc = require("./colorfunc");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tooltipProps = {
  coloring: 'dark',
  textSize: 'xs'
};
var ColorPickr = /*#__PURE__*/function (_React$Component) {
  _inherits(ColorPickr, _React$Component);
  var _super = _createSuper(ColorPickr);
  function ColorPickr(props) {
    var _this;
    _classCallCheck(this, ColorPickr);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "overrideValue", function (cssColor, shouldUpdateInitialValue) {
      var emitOnChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var color = _this.assignColor(cssColor);
      var cb = function cb() {
        return emitOnChange && _this.emitOnChange();
      };
      if (shouldUpdateInitialValue) {
        _this.setState({
          color: color,
          initialValue: color
        }, cb);
      } else {
        _this.setState({
          color: color
        }, cb);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "emitOnChange", function () {
      var _this$state = _this.state,
        color = _this$state.color,
        mode = _this$state.mode,
        colorSpace = _this$state.colorSpace;
      _this.props.onChange(_objectSpread({
        mode: mode,
        colorSpace: colorSpace
      }, color));
    });
    _defineProperty(_assertThisInitialized(_this), "setNextColor", function (obj) {
      var color = _this.state.color;
      _this.setState({
        color: _objectSpread(_objectSpread({}, color), obj)
      }, _this.emitOnChange);
    });
    _defineProperty(_assertThisInitialized(_this), "changeHSL", function (channels) {
      var color = _this.state.color;
      var nextColor = _objectSpread(_objectSpread({}, color), channels);
      var h = nextColor.h,
        s = nextColor.s,
        l = nextColor.l;
      var rgb = (0, _colorfunc.hsl2rgb)(h, s, l);
      var hex = (0, _colorfunc.rgb2hex)(rgb.r, rgb.g, rgb.b);
      _this.setNextColor(_objectSpread(_objectSpread(_objectSpread({}, nextColor), rgb), {
        hex: hex
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "onXYChange", function (_ref) {
      var x = _ref.x,
        y = _ref.y;
      _this.changeHSL({
        s: Math.round(x),
        l: 100 - Math.round(y)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "changeRGB", function (channels) {
      var color = _this.state.color;
      var nextColor = _objectSpread(_objectSpread({}, color), channels);
      var r = nextColor.r,
        g = nextColor.g,
        b = nextColor.b;
      var hsl = (0, _colorfunc.rgb2hsl)(r, g, b);
      var hex = (0, _colorfunc.rgb2hex)(r, g, b);
      _this.setNextColor(_objectSpread(_objectSpread(_objectSpread({}, nextColor), hsl), {
        hex: hex
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "getColorSpaceOutput", function () {
      var _this$state2 = _this.state,
        colorSpace = _this$state2.colorSpace,
        color = _this$state2.color;
      var h = color.h,
        s = color.s,
        l = color.l,
        a = color.a,
        r = color.r,
        g = color.g,
        b = color.b,
        hex = color.hex;
      switch (colorSpace) {
        case 'hex':
          return "#".concat(hex);
        case 'hsl':
          return a < 1 ? "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(a, ")") : "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
        case 'rgb':
          return a < 1 ? "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a, ")") : "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
      }
    });
    _defineProperty(_assertThisInitialized(_this), "changeColor", function (value) {
      var result = _colorString["default"].get(value) || _colorString["default"].get("#".concat(value));
      if (result) {
        var model = result.model,
          _value = result.value;
        switch (model) {
          case 'hsl':
          case 'hwb':
            return _this.changeHSL({
              h: _value[0],
              s: _value[1],
              l: _value[2],
              a: _value[3]
            });
          case 'rgb':
            return _this.changeRGB({
              r: _value[0],
              g: _value[1],
              b: _value[2],
              a: _value[3]
            });
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      var initialValue = _this.state.initialValue;
      _this.setState({
        color: initialValue
      }, _this.emitOnChange);
    });
    _defineProperty(_assertThisInitialized(_this), "setMode", function (mode) {
      _this.setState({
        mode: mode
      });
    });
    _defineProperty(_assertThisInitialized(_this), "setColorSpace", function (colorSpace) {
      _this.setState({
        colorSpace: colorSpace
      }, _this.emitOnChange);
    });
    _defineProperty(_assertThisInitialized(_this), "getColorCoords", function () {
      var color = _this.state.color;
      return {
        xmax: 100,
        ymax: 100,
        x: color.s,
        y: 100 - color.l
      };
    });
    var _mode = props.mode,
      _colorSpace = props.colorSpace,
      _initialValue = props.initialValue;
    var _color = _this.assignColor(_initialValue);
    _this.state = {
      mode: _mode,
      initialValue: _color,
      interimValue: null,
      colorSpace: _colorSpace,
      color: _color
    };
    return _this;
  }
  _createClass(ColorPickr, [{
    key: "assignColor",
    value: function assignColor(v) {
      var alpha = this.props.alpha;
      var color = (0, _colorfunc.getColor)(v);
      if (!alpha && color.a < 1) {
        console.warn("[ColorPickr] ".concat(v, " contains an alpha channel \"").concat(color.a, "\" but alpha is set to \"false\". Resetting to \"1\"."));
        color = _objectSpread(_objectSpread({}, color), {
          a: 1
        });
      }
      return color;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var mounted = this.props.mounted;
      if (mounted) {
        mounted(this);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state3 = this.state,
        color = _this$state3.color,
        mode = _this$state3.mode,
        colorSpace = _this$state3.colorSpace,
        i = _this$state3.initialValue,
        interimValue = _this$state3.interimValue;
      var r = color.r,
        g = color.g,
        b = color.b,
        h = color.h,
        s = color.s,
        l = color.l,
        hex = color.hex;
      var _this$props = this.props,
        theme = _this$props.theme,
        readOnly = _this$props.readOnly,
        reset = _this$props.reset,
        alpha = _this$props.alpha,
        discRadius = _this$props.discRadius,
        eyedropper = _this$props.eyedropper;
      var a = Math.round(color.a * 100);
      var themeObject = _objectSpread(_objectSpread({}, _theme.defaultTheme), theme);
      if (!readOnly) {
        themeObject.numberInput = "".concat(themeObject.numberInput, " bg-white");
      } else {
        themeObject.xyControlContainer = "".concat(themeObject.xyControlContainer, " events-none");
      }
      var themer = (0, _autokey.autokey)((0, _reactThemeable["default"])(themeObject));
      var rgbBackground = "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
      var rgbaBackground = "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(color.a, ")");
      var hueBackground = "hsl(".concat(h, ", 100%, 50%)");
      var saturationBackground = "hsl(".concat(h, ",").concat(s, "%,50%)");
      var lightnessBackground = "hsl(".concat(h, ",100%,").concat(l, "%)");
      var redLowBackground = "rgb(0, ".concat(g, ",").concat(b, ")");
      var redHighBackground = "rgb(255,".concat(g, ",").concat(b, ")");
      var greenLowBackground = "rgb(".concat(r, ",0,").concat(b, ")");
      var greenHighBackground = "rgb(".concat(r, ",255,").concat(b, ")");
      var blueLowBackground = "rgb(".concat(r, ",").concat(g, ",0)");
      var blueHighBackground = "rgb(".concat(r, ",").concat(g, ",255)");
      var configuration = {
        h: {
          name: 'Hue',
          value: h,
          max: 360,
          displayValue: hueBackground,
          trackBackground: "linear-gradient(\n          to left,\n          #ff0000 0%,\n          #ff0099 10%,\n          #cd00ff 20%,\n          #3200ff 30%,\n          #0066ff 40%,\n          #00fffd 50%,\n          #00ff66 60%,\n          #35ff00 70%,\n          #cdff00 80%,\n          #ff9900 90%,\n          #ff0000 100%\n        ",
          onChange: function onChange(v) {
            return _this2.changeHSL({
              h: v
            });
          }
        },
        s: {
          name: 'Saturation',
          value: s,
          max: 100,
          displayValue: saturationBackground,
          trackBackground: "linear-gradient(to left, ".concat(hueBackground, " 0%, #bbb 100%)"),
          onChange: function onChange(v) {
            return _this2.changeHSL({
              s: v
            });
          }
        },
        l: {
          name: 'Lightness',
          value: l,
          max: 100,
          displayValue: lightnessBackground,
          trackBackground: "linear-gradient(to left, #fff 0%, ".concat(hueBackground, " 50%, #000 100%)"),
          onChange: function onChange(v) {
            return _this2.changeHSL({
              l: v
            });
          }
        },
        r: {
          name: 'Red',
          value: r,
          max: 255,
          displayValue: rgbBackground,
          trackBackground: "linear-gradient(to left, ".concat(redHighBackground, " 0%, ").concat(redLowBackground, " 100%)"),
          onChange: function onChange(v) {
            return _this2.changeRGB({
              r: v
            });
          }
        },
        g: {
          name: 'Green',
          value: g,
          max: 255,
          displayValue: rgbBackground,
          trackBackground: "linear-gradient(to left, ".concat(greenHighBackground, " 0%, ").concat(greenLowBackground, " 100%)"),
          onChange: function onChange(v) {
            return _this2.changeRGB({
              g: v
            });
          }
        },
        b: {
          name: 'Blue',
          value: b,
          max: 255,
          displayValue: rgbBackground,
          trackBackground: "linear-gradient(to left, ".concat(blueHighBackground, " 0%, ").concat(blueLowBackground, " 100%)"),
          onChange: function onChange(v) {
            return _this2.changeRGB({
              b: v
            });
          }
        },
        a: {
          name: 'Alpha',
          value: a,
          max: 100,
          displayValue: "hsla(".concat(h, ",").concat(s, "%,").concat(l, "%,").concat(color.a, ")"),
          trackBackground: "linear-gradient(to left, ".concat(rgbBackground, " 0%, rgba(").concat(r, ",").concat(g, ",").concat(b, ",0) 100%)"),
          onChange: function onChange(v) {
            return _this2.changeHSL({
              a: v / 100
            });
          }
        }
      };
      var discUI = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", themer('gradientContainer'), /*#__PURE__*/_react["default"].createElement(_xyInput.XYInput, _extends({}, this.getColorCoords(), {
        isDark: (0, _colorfunc.isDark)([r, g, b]),
        backgroundColor: "#".concat(hex),
        discRadius: discRadius,
        theme: {
          xyControlContainer: themeObject.xyControlContainer,
          xyControl: themeObject.xyControl,
          xyControlDark: themeObject.xyControlDark,
          xyControlDisabled: themeObject.xyControlDisabled
        },
        disabled: readOnly,
        onChange: this.onXYChange
      }), /*#__PURE__*/_react["default"].createElement("div", _extends({}, themer('gradient'), {
        style: {
          background: hueBackground
        }
      })), /*#__PURE__*/_react["default"].createElement("div", themer('gradient', 'gradientHue')))), /*#__PURE__*/_react["default"].createElement("div", themer('sliderContainer'), /*#__PURE__*/_react["default"].createElement(_sliderInput.SliderInput, {
        id: "hue",
        trackStyle: {
          background: configuration.h.trackBackground
        },
        min: 0,
        max: configuration.h.max,
        value: h,
        colorValue: configuration.h.displayValue,
        disabled: readOnly,
        onChange: configuration.h.onChange
      }), alpha && /*#__PURE__*/_react["default"].createElement(_sliderInput.SliderInput, {
        id: "alpha",
        trackStyle: {
          background: configuration.a.trackBackground
        },
        min: 0,
        max: configuration.a.max,
        value: a,
        colorValue: configuration.a.displayValue,
        disabled: readOnly,
        onChange: configuration.a.onChange
      })));
      var renderValues = function renderValues(channel, index) {
        var _ref2 = configuration[channel],
          name = _ref2.name,
          value = _ref2.value,
          max = _ref2.max,
          displayValue = _ref2.displayValue,
          trackBackground = _ref2.trackBackground,
          onChange = _ref2.onChange;
        return /*#__PURE__*/_react["default"].createElement("div", _extends({}, themer('valuesMode'), {
          key: index
        }), /*#__PURE__*/_react["default"].createElement("span", _extends({
          title: name
        }, themer('valuesModeLabel')), channel), /*#__PURE__*/_react["default"].createElement("div", themer('valuesModeSlider'), /*#__PURE__*/_react["default"].createElement(_sliderInput.SliderInput, {
          id: channel,
          trackStyle: {
            background: trackBackground
          },
          min: 0,
          max: max,
          value: value,
          colorValue: displayValue,
          disabled: readOnly,
          onChange: onChange
        })), /*#__PURE__*/_react["default"].createElement("div", themer('valuesModeInput'), /*#__PURE__*/_react["default"].createElement(_numberInput.NumberInput, {
          id: channel,
          min: 0,
          max: max,
          value: value,
          theme: {
            numberInput: themeObject.numberInput
          },
          onChange: onChange,
          readOnly: readOnly
        })));
      };
      var valuesUI = /*#__PURE__*/_react["default"].createElement("div", themer('valuesModeContainer'), /*#__PURE__*/_react["default"].createElement("div", themer('valuesModeGroup'), ['h', 's', 'l'].map(renderValues)), /*#__PURE__*/_react["default"].createElement("div", themer('valuesModeGroup'), ['r', 'g', 'b'].map(renderValues)), alpha && /*#__PURE__*/_react["default"].createElement("div", themer('valuesModeGroup'), ['a'].map(renderValues)));
      var resetButton = /*#__PURE__*/_react["default"].createElement("button", _extends({}, themer('swatch'), readOnly ? {
        disabled: true,
        'aria-disabled': true
      } : {}, {
        "aria-label": "Reset color",
        "data-testid": "color-reset",
        type: "button",
        style: {
          backgroundColor: "rgba(".concat(i.r, ", ").concat(i.g, ", ").concat(i.b, ", ").concat(i.a, ")")
        },
        onClick: this.reset
      }), !readOnly && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        name: "undo",
        inline: true
      }));
      if (!readOnly) {
        resetButton = /*#__PURE__*/_react["default"].createElement(_tooltip["default"], _extends({}, tooltipProps, {
          content: "Reset"
        }), resetButton);
      }
      var copySupported = !readOnly && _copyButton["default"].isCopySupported();
      var copyButton = /*#__PURE__*/_react["default"].createElement("div", _extends({}, themer('swatch'), {
        style: {
          backgroundColor: rgbaBackground
        }
      }));
      if (copySupported) {
        copyButton = /*#__PURE__*/_react["default"].createElement(_copyButton["default"], {
          text: this.getColorSpaceOutput(),
          block: true,
          tooltipColoring: tooltipProps.coloring,
          tooltipTextSize: tooltipProps.textSize
        }, /*#__PURE__*/_react["default"].createElement("button", _extends({}, themer('swatch'), readOnly ? {
          disabled: true,
          'aria-disabled': true
        } : {}, {
          "aria-label": "Copy color",
          "data-testid": "color-copy",
          type: "button"
        }, themer('swatch'), {
          style: {
            backgroundColor: rgbaBackground
          }
        }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
          name: "clipboard",
          inline: true
        })));
      }
      return /*#__PURE__*/_react["default"].createElement("div", themer('container'), /*#__PURE__*/_react["default"].createElement("div", themer('controlsContainer'), /*#__PURE__*/_react["default"].createElement("div", themer('modesContainer'), /*#__PURE__*/_react["default"].createElement(_tooltip["default"], _extends({}, tooltipProps, {
        content: "Disc"
      }), /*#__PURE__*/_react["default"].createElement("button", _extends({}, themer('modeToggle', mode === 'disc' && 'modeToggleActive'), {
        "data-testid": "mode-disc",
        onClick: function onClick() {
          return _this2.setMode('disc');
        },
        type: "button"
      }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        name: "circle"
      }))), /*#__PURE__*/_react["default"].createElement(_tooltip["default"], _extends({}, tooltipProps, {
        content: "Values"
      }), /*#__PURE__*/_react["default"].createElement("button", _extends({}, themer('modeToggle', mode === 'values' && 'modeToggleActive'), {
        "data-testid": "mode-values",
        onClick: function onClick() {
          return _this2.setMode('values');
        },
        type: "button"
      }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        name: "boolean"
      })))), eyedropper && 'EyeDropper' in window && /*#__PURE__*/_react["default"].createElement(_tooltip["default"], _extends({}, tooltipProps, {
        content: "Pick color"
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_eyedropperInput.EyedropperInput, {
        disabled: readOnly,
        onChange: this.changeColor,
        theme: {
          eyeDropper: themeObject.eyeDropper,
          eyeDropperIcon: themeObject.eyeDropperIcon
        }
      })))), mode === 'disc' && discUI, mode === 'values' && valuesUI, /*#__PURE__*/_react["default"].createElement("div", themer('modeInputContainer'), /*#__PURE__*/_react["default"].createElement("div", themer('colorSpaceContainer'), /*#__PURE__*/_react["default"].createElement(_controlSelect["default"], {
        id: "colorspace",
        value: colorSpace,
        themeControlWrapper: "w-full",
        themeControlSelectContainer: themeObject.colorSpaceSelectContainer,
        themeControlSelect: themeObject.colorSpaceSelect,
        onChange: this.setColorSpace,
        options: [{
          label: color.a < 1 ? 'HSLA' : 'HSL',
          value: 'hsl'
        }, {
          label: color.a < 1 ? 'RGBA' : 'RGB',
          value: 'rgb'
        }, {
          label: 'HEX',
          value: 'hex'
        }]
      })), /*#__PURE__*/_react["default"].createElement("div", themer('colorInputContainer'), /*#__PURE__*/_react["default"].createElement("input", _extends({}, readOnly ? {
        readOnly: true
      } : {}, themer('numberInput'), {
        "data-testid": "color-input",
        value: interimValue || this.getColorSpaceOutput(),
        onChange: function onChange(e) {
          _this2.setState({
            interimValue: e.target.value
          });
          _this2.changeColor(e.target.value);
        },
        onBlur: function onBlur() {
          return _this2.setState({
            interimValue: null
          });
        },
        type: "text"
      })))), /*#__PURE__*/_react["default"].createElement("div", themer('swatchCompareContainer'), reset && /*#__PURE__*/_react["default"].createElement("div", themer('tileBackground', 'currentSwatchContainer'), resetButton), /*#__PURE__*/_react["default"].createElement("div", themer('tileBackground', 'newSwatchContainer'), copyButton)));
    }
  }]);
  return ColorPickr;
}(_react["default"].Component);
_defineProperty(ColorPickr, "defaultProps", {
  initialValue: '#000',
  discRadius: 18,
  alpha: true,
  eyedropper: true,
  reset: true,
  mode: 'disc',
  colorSpace: 'hex',
  theme: {},
  readOnly: false
});
var _default = ColorPickr;
exports["default"] = _default;